import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import { Accordion, AccordionDetails } from "@material-ui/core";
import { useRowFlexStyles } from "@mui-treasury/styles/flex/row";
import clsx from "clsx";
import Hidden from "@material-ui/core/Hidden";
import { useHistory } from "react-router-dom";

import { updateNotificationById } from "../../actions/notification-actions";
import useStyles from "../../styles/components/notification/stylesNotificationHolder";
import { News } from "../../utils/services/cache/ClientCache";
import { setLearningContentSession, setLearningContentLevel, setTime } from "../../utils/helpers/others/SessionHelper";

const NotificationHolder = ({ notification }) => {
    const classes = useStyles();
    const flexStyles = useRowFlexStyles();
    const history = useHistory();
    const [group, setGroup] = useState("");
    const [title, setTitle] = useState("");

    useEffect(() => {
        if (notification.surveyVM !== null) {
            setGroup("New Survey");
            setTitle(notification.surveyVM.title);
        } else if (notification.newsVM !== null) {
            setGroup("New News");
            setTitle(notification.newsVM.title);
        } else if (notification.nonTraitLearningContentVM !== null) {
            setGroup("New Learning Content");
            setTitle(notification.nonTraitLearningContentVM.title);
        } else if (notification.recommendedLearningContentVM !== null) {
            setGroup("New Recommended Learning Content");
            setTitle(notification.recommendedLearningContentVM.title);
        }
        else if (notification.challengeVM !== null) {
            setGroup("Challenge");
            setTitle(notification.challengeVM.title);
        }
    }, []);

    const handleClick = () => {
        const update = async () => {
            await updateNotificationById(notification.id);
        };

        update();

        if (notification.surveyVM !== null) {
            history.push("/Survey");
        } else if (notification.newsVM !== null) {
            News.setNewsId(notification.newsVM.newsId);
            history.push("/NewsDetail");
        } else if (notification.nonTraitLearningContentVM !== null) {
            const learningContent = {
                learningContentCategoryId: 0,
                learningContentCategoryName: "Non Trait Learning Contents",
                learningContentId: notification.nonTraitLearningContentVM.learningContentId,
                isAccessible: notification.nonTraitLearningContentVM.isAccessible,
                isCompleted: notification.nonTraitLearningContentVM.isCompleted,
                isRecommended: notification.nonTraitLearningContentVM.isRecommended,
            };
            setLearningContentSession(JSON.stringify(learningContent));
            setTime(new Date().getTime())
            history.push("/LearningContent");
        } else if (notification.recommendedLearningContentVM !== null) {
            setLearningContentLevel(notification.recommendedLearningContentVM.levelText > 0 ? notification.recommendedLearningContentVM.levelText : 0)
            const learningContent = {
                learningContentCategoryId: notification.recommendedLearningContentVM.traitGroupId,
                learningContentCategoryName: notification.recommendedLearningContentVM.traitGroupName,
                learningContentId: notification.recommendedLearningContentVM.learningContentId,
            };
            setLearningContentSession(JSON.stringify(learningContent));
            setTime(new Date().getTime())
            history.push("/LearningContent");
        }
        else if (notification.challengeVM !== null) history.push(`/ChallengeDetail/${notification.challengeVM.challengeId}`);
    };

    return (
        <div>
            <Accordion
                expanded={true}
                width={100}
                className={
                    notification.isRead
                        ? clsx(classes.rootContain)
                        : clsx(classes.rootContainRead, classes.rootContain)
                }
                onClick={handleClick}
            >
                <div className={clsx(classes.rootBody)}>
                    <Hidden mdUp>
                        <div>
                            <AccordionDetails style={{ display: "unset" }}>
                                <Typography
                                    variant="subtitle2"
                                    classes={{ root: clsx(classes.rootGroup, !notification.isRead && classes.textGreen) }}
                                >
                                    {group}
                                </Typography>
                                <Typography classes={{ root: clsx(classes.rootTitle, !notification.isRead && classes.textBold) }}>{title}</Typography>
                            </AccordionDetails>
                        </div>
                    </Hidden>
                </div>

                <div
                    className={clsx(classes.rootBody)}
                >
                    <Hidden smDown>
                        <div>
                            <AccordionDetails style={{ display: "unset" }}>
                                <Typography
                                    variant="subtitle2"
                                    classes={{ root: clsx(classes.rootGroup, !notification.isRead && classes.textGreen) }}
                                >
                                    {group}
                                </Typography>
                                <Typography classes={{ root: clsx(classes.rootTitle, !notification.isRead && classes.textBold) }}>{title}</Typography>
                            </AccordionDetails>
                        </div>
                    </Hidden>
                </div>
            </Accordion>
        </div>
    );
};

export { NotificationHolder as default };